import BaseModel from '../base/BaseModel.model';
import Evaluacion from './evaluacion.model';
import Pregunta from './pregunta.model';
import { AnswerType } from '@/enums/AsnwerType';

export default class RespuestaModel extends BaseModel {

    public valorBool:boolean | null;
    public valorString:string | Boolean | null;
    public valorInt:Number;
    public preguntaId:number;
    public evaluacionId: number;
    public preguntaOpcionRespuestaId: number;
    public tipoRespuesta: AnswerType | null;
    public pregunta: Pregunta | null;
    public evaluacion: Evaluacion | null;

    constructor(){
        super();
        this.init();
    }

    init(){

        this.valorBool = null;
        this.valorString = null;
        this.valorInt = 0;
        this.preguntaId = 0;
        this.evaluacion = null;
        this.evaluacionId = 0;
        this.preguntaOpcionRespuestaId = 0;
    }
}